<div class="field">
    <div class="tooltip">
        <input type="number" [ngModel]="currentValue" (ngModelChange)="onCurrentValueChange($event)" [ngClass]="{
        'changed': modelValue.isFieldChanged(property),
        'error': hasErrors()
    }" [disabled]="isDisabled" (input)="handleManualChange()" (change)="handleValueChange()" />
        <div class="tooltiptext" *ngIf="errorMessages?.length">
            <div *ngFor="let error of errorMessages">{{error}}</div>
        </div>
    </div>
    <calibration-set-table-field-attributes *ngIf="!hideAttributeButtons"
        [identifiers]="getCalibrationSetTableFieldIdentifier()" [showPopover]="true"
        [attributePopupTitleDetails]="attributePopupTitleDetails">
    </calibration-set-table-field-attributes>
</div>
